import CustomerService from '../../services/customerService';
import { STORE } from '../../enums/store';
export default {
    async GET_SELECTED_CUSTOMER_DETAILS({ commit }, { utils, cust_id }) {
        const customerService = new CustomerService(utils)
        let customers_details = await customerService.getCustomerDetails(cust_id);
        commit(`${STORE.VEHICLE}/SET_SELECTED_CUSTOMER_DETAILS`,customers_details, { root: true })
    }
}